import React from 'react';
import ArchitectureCanvas from './ArchitectureCanvas';
import TaskNavigator from './TaskNavigator';

const ArchitectureViewport: React.FC = () => {
    return (
        <div className="flex-1 bg-stone-950 relative overflow-hidden flex items-center justify-center">
            <TaskNavigator />
            <ArchitectureCanvas />
        </div>
    );
};

export default ArchitectureViewport;
